module.exports = __webpack_public_path__ + "static/media/front.673a2e14.jpg";